import AwardRow from "@/components/AwardRow"
import SectionHeading from "@/components/SectionHeading"
import { createDataAttribute } from "next-sanity"

interface AwardsListProps {
	heading: string
	awards: {
		date: string
		category: string
		name: string
	}[]
	documentId: string
	_key: string
}

export default function AwardsList({heading, awards, documentId, _key}:AwardsListProps) {
	return (
		<div className={`section section--award-list px-site`}
			key={_key}
			data-sanity={createDataAttribute({
				id: documentId,
				type: 'project',
				path: `contentBlocks[_key=="${_key}"]`,
			}).toString()}>
			<div className="mb-section--sm sm:text-center">
				<SectionHeading heading={heading || `Awards & Recognition`} />
			</div>
			<div className="awards-list">
				{awards?.map((award, index) => (
					<AwardRow
						key={`${award?.name}-${index}`}
						date={award?.date}
						ceremony={award?.category}
						award={award?.name}
					/>
				))}
			</div>
		</div>
	)
}